// InfoSidebar component
import './InfoSidebar.css';
export function InfoSidebar() {
	return (
		<div id="side-info-column" className="inner-sidebar">
			<div
				id="gpi-results-filter"
				className="gform-settings-panel__content postbox gform-settings-panel"
			>
				<h2>Powered by GP Inventory</h2>
				<div id="gpi-results-filter-content">
					<p>
						Take control of your inventory with advanced tracking,
						dynamic stock limits, and seamless automation. GP
						Inventory—and other powerful perks—help you manage
						inventory smarter.
					</p>
					<a
						href="https://gravitywiz.com/documentation/gravity-forms-inventory/"
						className="button secondary"
						target="_blank"
						rel="noopener noreferrer"
					>
						Learn More
					</a>
				</div>
			</div>
		</div>
	);
}
